import { getRuntimeEnv } from '../runtimeEnv';
const useEnv = () => getRuntimeEnv();
export default useEnv;
